@use '~/theme/theme' as *;
@use '~/theme/typography';

.recap {
  position: sticky;
  bottom: 0;
  z-index: 1;
  background: white;
  border-top: border(grey-200);
  padding-top: spacing(3);
  padding-bottom: spacing(3);
}

.unbalanced {
  color: color(lobster-600);
}

.actions {
  margin-top: spacing(2);
}

.check {
  color: color(green-800);
}

.cross {
  color: color(lobster-800);
}

.tooltipIcon {
  cursor: pointer;
}

.tooltip {
  background: white;
  min-width: 450px;

  table {
    border-spacing: 0;
  }

  th,
  td {
    border: none;
    padding: spacing(1);

    @include typography.tabular-nums;
    @include typography.caption;
    @include typography.medium;

    text-align: right;
  }

  td:first-of-type {
    padding: spacing(1) spacing(2);
    text-align: left;
  }

  th {
    background-color: color(grey-100);
    color: color(grey-700);
  }
}
